/**
 * Бейдж непрочитанных на иконке приложения в Доке (баг Антона 2026-10-09 10:58:
 * «Mac-приложение не показывает число непрочитанных на иконке»).
 *
 * Причина бага (замер 09.10): веб никогда не отдавал число оболочке —
 * ни нативной Mac-обёртке (WKWebView), ни Electron. Число в заголовке
 * вкладки было, а до Дока оно не доходило.
 *
 * Число — ТО ЖЕ, что в заголовке и на иконках рельса (totals.allUnread):
 * два независимых подсчёта разошлись бы.
 *
 * Каналы (каждый — no-op, если его нет; в обычном браузере не делается ничего):
 *  - нативная Mac-обёртка: window.webkit.messageHandlers.algBadge.postMessage({count});
 *  - Electron-обёртка: window.ALGDesktop.setBadge(count) (мост уже есть в preload.js).
 *
 * Отправляем только при изменении числа и один раз при монтировании,
 * чтобы после перезагрузки страницы бейдж синхронизировался с реальным числом.
 */
import { useEffect } from "react";

type BadgeHandler = { postMessage(message: unknown): unknown };
type BadgeWindow = Window & {
  webkit?: { messageHandlers?: { algBadge?: BadgeHandler } };
};

export function postDockBadge(count: number): void {
  const n = Number.isFinite(count) && count > 0 ? Math.floor(count) : 0;
  const w = window as BadgeWindow;
  try {
    w.webkit?.messageHandlers?.algBadge?.postMessage({ count: n });
  } catch {
    // Обёртка без обработчика или старая сборка — бейдж не критичен.
  }
  try {
    const desktop = window.ALGDesktop as { setBadge?: (count: number) => void } | undefined;
    desktop?.setBadge?.(n);
  } catch {
    /* не критично */
  }
}

export function useDockBadge(unread: number): void {
  useEffect(() => {
    postDockBadge(unread);
  }, [unread]);
}
